import { createStore } from "vuex";
import { config } from "vuex-module-decorators";

import { auth } from "@/store/modules/AuthModule";
import BodyModule from "@/store/modules/BodyModule";
import BreadcrumbsModule from "@/store/modules/BreadcrumbsModule";
import ConfigModule from "@/store/modules/ConfigModule";
import { menu } from "@/store/modules/MenuModule";
import { emitente } from "@/store/modules/EmitenteModule";
import { cep } from "@/store/modules/CepModule";
import { softwareHouse } from "@/store/modules/SoftwareHouseModule";
import { usuario } from "@/store/modules/UsuarioModule";
import { grupo } from "@/store/modules/GrupoModule";
import { produto } from "@/store/modules/ProdutoModule";
import { tipoUsuario } from "@/store/modules/TipoUsuarioModule";
import { usuarioDado } from "@/store/modules/UsuarioDadoModule";
import { usuarioEndereco } from "@/store/modules/UsuarioEnderecoModule";
import { usuarioTelefone } from "@/store/modules/UsuarioTelefoneModule";
import { adicional } from "@/store/modules/AdicionalModule";
import { adicionalGrupo } from "@/store/modules/AdicionalGrupoModule";
import { adicionalGrupoItem } from "@/store/modules/AdicionalGrupoItemModule";
import { estoque } from "@/store/modules/EstoqueModule";
import { estoqueImagem } from "@/store/modules/EstoqueImagemModule";
import { estoqueVariacao } from "@/store/modules/EstoqueVariacaoModule";
import { subGrupo } from "@/store/modules/SubGrupoModule";
import { restricao } from "@/store/modules/RestricaoModule";
import { restricaoPadrao } from "@/store/modules/RestricaoPadraoModule";
import { emitenteTipoUsuario } from "@/store/modules/EmitenteTipoUsuarioModule";
import { emitenteRestricao } from "@/store/modules/EmitenteRestricaoModule";
import { emitenteRestricaoPadrao } from "@/store/modules/EmitenteRestricaoPadraoModule";
import { emitenteSoftwareHouse } from "@/store/modules/EmitenteSoftwareHouseModule";
import { cliente } from "@/store/modules/ClienteModule";
import { clienteEmail } from "@/store/modules/ClienteEmailModule";
import { clienteEndereco } from "@/store/modules/ClienteEnderecoModule";
import { clienteTelefone } from "@/store/modules/ClienteTelefoneModule";
import { transportadora } from "@/store/modules/TransportadoraModule";
import { transportadoraEmail } from "@/store/modules/TransportadoraEmailModule";
import { transportadoraEndereco } from "@/store/modules/TransportadoraEnderecoModule";
import { transportadoraTelefone } from "@/store/modules/TransportadoraTelefoneModule";
import { pedido } from "@/store/modules/PedidoModule";
import { pedidoCliente } from "@/store/modules/PedidoClienteModule";
import { pedidoEnderecoEntrega } from "@/store/modules/PedidoEnderecoEntregaModule";
import { pedidoItem } from "@/store/modules/PedidoItemModule";
import { pedidoPagamento } from "@/store/modules/PedidoPagamentoModule";
import { pedidoSubItem } from "@/store/modules/PedidoSubItemModule";
import { pedidoReceber } from "@/store/modules/PedidoReceberModule";
import ThemeModeModule from "@/store/modules/ThemeModeModule";
import { conta } from "@/store/modules/ContaModule";
import { custo } from "@/store/modules/CustoModule";
import { compartilhamento } from "@/store/modules/CompartilhamentoModule";
import { condicao } from "@/store/modules/CondicaoModule";
import { vendedor } from "@/store/modules/VendedorModule";
import { vendedorEmail } from "@/store/modules/VendedorEmailModule";
import { vendedorEndereco } from "@/store/modules/VendedorEnderecoModule";
import { vendedorTelefone } from "@/store/modules/VendedorTelefoneModule";
import { regraComissaoVendedor } from "@/store/modules/RegraComissaoVendedorModule";
import { situacaoPedido } from "@/store/modules/SituacaoPedidoModule";
import { categoriaPedido } from "@/store/modules/CategoriaPedidoModule";
import { tipoPedido } from "@/store/modules/TipoPedidoModule";
import { localPedido } from "@/store/modules/LocalPedidoModule";
import { motorista } from "@/store/modules/MotoristaModule";
import { motoristaEmail } from "@/store/modules/MotoristaEmailModule";
import { motoristaEndereco } from "@/store/modules/MotoristaEnderecoModule";
import { motoristaTelefone } from "@/store/modules/MotoristaTelefoneModule";
import { cidade } from "@/store/modules/CidadeModule";
import { pais } from "@/store/modules/PaisModule";
import { pedidoEndereco } from "@/store/modules/PedidoEnderecoModule";
import { pedidoAnexo } from "@/store/modules/PedidoAnexoModule";
import { pedidoItemDetCodBarras } from "@/store/modules/PedidoItemDetCodBarrasModule";
import { pedidoItemDetMetragem } from "@/store/modules/PedidoItemDetMetragemModule";
import { pedidoItemDetPesagem } from "@/store/modules/PedidoItemDetPesagemModule";
import { pedidoItemDetTipoEmbalagem } from "@/store/modules/PedidoItemDetTipoEmbalagemModule";
import { pedidoItemDetTolerancia } from "@/store/modules/PedidoItemDetToleranciaModule";
import { tipoProduto } from "@/store/modules/TipoProdutoModule";
import { aliquota } from "@/store/modules/AliquotaModule";
import { cest } from "@/store/modules/CestModule";
import { cfop } from "@/store/modules/CfopModule";
import { estoqueSt } from "@/store/modules/EstoqueStModule";
import { stUf } from "@/store/modules/StUfModule";
import { generoSped } from "@/store/modules/GeneroSpedModule";
import { servicosCnaeDet } from "@/store/modules/ServicosCnaeDetModule";
import { servicosCnaeGrupos } from "@/store/modules/ServicosCnaeGruposModule";
import { produtoTributacao } from "@/store/modules/ProdutoTributacaoModule";
import { tributacoes } from "@/store/modules/TributacoesModule";
import { ibpt } from "@/store/modules/IbptModule";
import { categoriaEstoque } from "@/store/modules/CategoriaEstoqueModule";
import { tipoEstoque } from "@/store/modules/TipoEstoqueModule";
import { configuracao } from "@/store/modules/ConfiguracaoModule";
import { labelDescricao } from "@/store/modules/LabelDescricaoModule";
import { kit } from "@/store/modules/KitModule";
import { prodKit } from "@/store/modules/ProdKitModule";
import { produtoSimulador } from "@/store/modules/ProdutoSimuladorModule";
import { produtoAdicional } from "@/store/modules/ProdutoAdicionalModule";
import { fornecedor } from "@/store/modules/FornecedorModule";
import { fornecedorEmail } from "@/store/modules/FornecedorEmailModule";
import { fornecedorEndereco } from "@/store/modules/FornecedorEnderecoModule";
import { fornecedorTelefone } from "@/store/modules/FornecedorTelefoneModule";
import { estoqueMoviOperacao } from "@/store/modules/EstoqueMoviOperacaoModule";
import { estoqueMovimentacao } from "@/store/modules/EstoqueMovimentacaoModule";
import { variacao } from "@/store/modules/VariacaoModule";
import { variacaoItem } from "@/store/modules/VariacaoItemModule";
import { modelosFaturamento } from "@/store/modules/ModelosFaturamentoModule";
import { faturamento } from "@/store/modules/FaturamentoModule";
import { controleEdicao } from "@/store/modules/ControleEdicaoModule";
import { auditoria } from "@/store/modules/AuditoriaModule";
import { gerenciadorNFe } from "@/store/modules/GerenciadorNFeModule";
import { chatGPT } from "@/store/modules/ChatGPTModule";
import { schema } from "@/store/modules/SchemaModule";
import { consultaAvancada } from "@/store/modules/ConsultaAvancadaModule";
import { inutilizacaoNFe } from "@/store/modules/InutilizacaoNFeModule";
import { cartaCorrecaoNFe } from "@/store/modules/CartaCorrecaoNFeModule";
import { versaoTabelaIbpt } from "@/store/modules/VersaoTabelaIbptModule";
import { faturamentoItem } from "@/store/modules/FaturamentoItemModule";
import { administrador } from "@/store/modules/AdministradorModule";
import { assistenteModulos } from "@/store/modules/AssistenteModulosModule";
import { ajuda } from "@/store/modules/AjudaModule";
import { ajudaCategoria } from "@/store/modules/AjudaCategoriaModule";
import { ajudaModuloCategoria } from "@/store/modules/AjudaModuloCategoriaModule";
import { relatorios } from "@/store/modules/RelatoriosModule";
import { relatoriosModulos } from "@/store/modules/RelatoriosModulosModule";
import { recaptcha } from "@/store/modules/RecaptchaModule";
import { distribuidorMaster } from "@/store/modules/DistribuidorMasterModule";
import { distribuidor } from "@/store/modules/DistribuidorModule";
import { revenda } from "@/store/modules/RevendaModule";
import { vendedorRevenda } from "@/store/modules/VendedorRevendaModule";
import { licencaRecebivel } from "@/store/modules/LicencaRecebivelModule";
import { sessaoUsuario } from "@/store/modules/SessaoUsuarioModule";
import { atualizacaoPlano } from "@/store/modules/AtualizacaoPlanoModule";
import { agenciaBoletoLicenca } from "@/store/modules/AgenciaBoletoLicencaModule";
import { boletoLicencaRecebivel } from "@/store/modules/BoletoLicencaRecebivelModule";
import { bloqueioLicenca } from "@/store/modules/BloqueioLicencaModule";
import { sessaoUsuarioConnection } from "@/store/modules/SessaoUsuarioConnectionModule";
import { ticket } from "@/store/modules/TicketModule";
import { ticketMensagem } from "@/store/modules/TicketMensagemModule";
import { generator } from "@/store/modules/GeneratorModule";
import { conversao } from "@/store/modules/ConversaoModule";
import { vendasCupom } from "@/store/modules/VendasCupomModule";
import { modelosVendasCupom } from "@/store/modules/ModelosVendasCupomModule";
import { gerenciadorNFCe } from "@/store/modules/GerenciadorNFCeModule";
import { inutilizacaoNFCe } from "@/store/modules/InutilizacaoNFCeModule";
import { vendasCupomItem } from "@/store/modules/VendasCupomItemModule";
import { configuracaoWhiteLabel } from "@/store/modules/ConfiguracaoWhiteLabelModule";
import { compra } from "@/store/modules/CompraModule";
import { compraItem } from "@/store/modules/CompraItemModule";
import { especie } from "@/store/modules/EspecieModule";
import { receber } from "@/store/modules/ReceberModule";
import { receberAnexo } from "@/store/modules/ReceberAnexoModule";
import { pagar } from "@/store/modules/PagarModule";
import { pagarAnexo } from "@/store/modules/PagarAnexoModule";
import { receberPagamento } from "@/store/modules/ReceberPagamentoModule";
import { pagarPagamento } from "@/store/modules/PagarPagamentoModule";
import { compraDFeManifesto } from "@/store/modules/CompraDFeManifestoModule";
import { compraDFeManifestoUltimaConsulta } from "@/store/modules/CompraDFeManifestoUltimaConsultaModule";
import { compraItemRelacionamentoFornecedor } from "@/store/modules/CompraItemRelacionamentoFornecedorModule";
import { tabelaCombustiveisMonofasica } from "@/store/modules/TabelaCombustiveisMonofasicaModule";
import { cstCClassTrib } from "@/store/modules/CstCClassTribModule";
import { tabelaNcmIBSCBS } from "@/store/modules/TabelaNcmIBSCBSModule";

config.rawError = true;

const store = createStore({
  modules: {
    auth,
    BodyModule,
    BreadcrumbsModule,
    ConfigModule,
    ThemeModeModule,
    menu,
    emitente,
    cep,
    softwareHouse,
    usuario,
    grupo,
    produto,
    tipoUsuario,
    usuarioDado,
    usuarioEndereco,
    usuarioTelefone,
    adicional,
    adicionalGrupo,
    adicionalGrupoItem,
    estoque,
    estoqueImagem,
    estoqueVariacao,
    subGrupo,
    restricao,
    restricaoPadrao,
    emitenteTipoUsuario,
    emitenteRestricao,
    emitenteRestricaoPadrao,
    emitenteSoftwareHouse,
    cliente,
    clienteEmail,
    clienteEndereco,
    clienteTelefone,
    transportadora,
    transportadoraEmail,
    transportadoraEndereco,
    transportadoraTelefone,
    pedido,
    pedidoCliente,
    pedidoEnderecoEntrega,
    pedidoItem,
    pedidoPagamento,
    pedidoSubItem,
    pedidoReceber,
    conta,
    custo,
    compartilhamento,
    condicao,
    vendedor,
    vendedorEmail,
    vendedorEndereco,
    vendedorTelefone,
    regraComissaoVendedor,
    situacaoPedido,
    categoriaPedido,
    tipoPedido,
    localPedido,
    motorista,
    motoristaEmail,
    motoristaEndereco,
    motoristaTelefone,
    cidade,
    pais,
    pedidoEndereco,
    pedidoAnexo,
    pedidoItemDetCodBarras,
    pedidoItemDetMetragem,
    pedidoItemDetPesagem,
    pedidoItemDetTipoEmbalagem,
    pedidoItemDetTolerancia,
    tipoProduto,
    aliquota,
    cest,
    cfop,
    estoqueSt,
    stUf,
    generoSped,
    servicosCnaeDet,
    servicosCnaeGrupos,
    produtoTributacao,
    tributacoes,
    ibpt,
    categoriaEstoque,
    tipoEstoque,
    configuracao,
    labelDescricao,
    kit,
    prodKit,
    produtoSimulador,
    produtoAdicional,
    fornecedor,
    fornecedorEmail,
    fornecedorEndereco,
    fornecedorTelefone,
    estoqueMoviOperacao,
    estoqueMovimentacao,
    variacao,
    variacaoItem,
    modelosFaturamento,
    faturamento,
    controleEdicao,
    auditoria,
    gerenciadorNFe,
    chatGPT,
    schema,
    consultaAvancada,
    inutilizacaoNFe,
    cartaCorrecaoNFe,
    versaoTabelaIbpt,
    faturamentoItem,
    administrador,
    assistenteModulos,
    ajuda,
    ajudaCategoria,
    ajudaModuloCategoria,
    relatorios,
    relatoriosModulos,
    recaptcha,
    distribuidorMaster,
    distribuidor,
    revenda,
    vendedorRevenda,
    licencaRecebivel,
    sessaoUsuario,
    atualizacaoPlano,
    agenciaBoletoLicenca,
    boletoLicencaRecebivel,
    bloqueioLicenca,
    sessaoUsuarioConnection,
    ticket,
    ticketMensagem,
    generator,
    conversao,
    vendasCupom,
    modelosVendasCupom,
    gerenciadorNFCe,
    inutilizacaoNFCe,
    vendasCupomItem,
    configuracaoWhiteLabel,
    compra,
    compraItem,
    especie,
    receber,
    receberAnexo,
    pagar,
    pagarAnexo,
    receberPagamento,
    pagarPagamento,
    compraDFeManifesto,
    compraDFeManifestoUltimaConsulta,
    compraItemRelacionamentoFornecedor,
    tabelaCombustiveisMonofasica,
    cstCClassTrib,
    tabelaNcmIBSCBS,
  },
});

export default store;
